// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"8703ba37","263":"16cf6c72"}[chunkId] + ".chunk.css";
};